import React from 'react';
import { createRoot } from 'react-dom/client';
import classnames from 'classnames';
import { NotificationService } from '../../services/notification-service';
import { Notification } from '../notification';

import style from './notification-manager.module.less';

export class NotificationManager extends React.Component {
  static render = (el, props) => {
    const root = createRoot(el);
    root.render(<NotificationManager {...props} />);
  };

  state = {
    notifications: [],
  };

  componentDidMount() {
    this.unsubscribeToNotificationService = NotificationService.subscribe(() => {
      const notifications = NotificationService.getNotifications();
      const removedNotifications = NotificationService.getNotificationsToRemove();

      this.setState({
        notifications: Object.keys(notifications).map((key) => notifications[key]),
        removedNotifications,
      });
    });
  }

  componentWillUnmount() {
    this.unsubscribeToNotificationService();
  }

  renderNotification(notificationConfig, removedNotifications) {
    const notificationClasses = classnames(style['notification-wrapper'], {
      [style.removed]: removedNotifications[notificationConfig.id] !== undefined,
    });
    return (
      <div key={notificationConfig.id} className={notificationClasses} id={notificationConfig.elementId}>
        <Notification {...notificationConfig} />
      </div>
    );
  }

  render() {
    const { notifications, removedNotifications } = this.state;
    return (
      <div className={style['notification-manager']}>
        <div className={style.notifications}>
          {notifications.map((notification) => this.renderNotification(notification, removedNotifications))}
        </div>
      </div>
    );
  }
}
